import { colors } from '@lmc/common/constants'
import { Checkbox, Form } from 'antd'
import type { CheckboxChangeEvent } from 'antd/lib/checkbox'
import React, { type CSSProperties, type ReactNode } from 'react'
import type { BaseInputProps } from '../../types/types'
import './InputCheckbox.less'
import { theme } from '../../config/theme'

export type InputCheckboxProps = {
  onChange?: (e?: CheckboxChangeEvent) => void
  value?: boolean
  fluid?: boolean
  style?: CSSProperties
  withoutInput?: boolean
  children?: ReactNode
  type?: string
} & BaseInputProps

function InputCheckbox({
  value,
  label,
  disabled,
  onChange,
  fluid,
  style,
  withoutInput,
  type,
  children,
  ...props
}: InputCheckboxProps) {
  const styles = {
    container: {
      display: 'flex',
      justifyContent: `${fluid ? 'space-between' : 'center'}`,
      alignItems: 'center',
      minHeight: 40,
      border: `1px solid ${colors.grey}`,
      borderRadius: 4,
      width: `${fluid ? '100%' : 'fit-content'}`,
      padding: '4px 12px',
      cursor: 'pointer',
      background: colors.white,
      cursot: 'pointer'
    },
    fluid: {
      border: `1px solid ${value ? theme.color.status.primary : colors.grey}`
    },
    label: {
      fontSize: 14,
      fontWeigh: 600,
      marginRight: 8
    }
  }

  return withoutInput ? (
    <Form.Item valuePropName="checked" name={type}>
      <Checkbox
        className="ant-custom-checkbox"
        style={{ display: 'flex', alignItems: 'center', width: 'fit-content' }}
        checked={value}
        disabled={disabled}
        {...props}
        onClick={onChange}
      >
        {children || label}
      </Checkbox>
    </Form.Item>
  ) : (
    <div
      style={{ ...styles.container, ...style, ...(fluid && styles.fluid) }}
      onClick={onChange}
    >
      <div style={styles.label}>{label || ''}</div>
      <Checkbox checked={value} disabled={disabled} {...props} />
    </div>
  )
}

export default InputCheckbox
